import apiMiddleware from "../api/apiMiddleware";

// list
export const list = async (page = 1, filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    
    if (filters.search) {
      params.append('search', filters.search);
    }
    if (filters.tour_type && filters.tour_type !== 'all') {
      params.append('tour_type', filters.tour_type);
    }
    if (filters.package_count && filters.package_count !== 'all') {
      params.append('package_count', filters.package_count);
    }
    
    const response = await apiMiddleware.get(`/package-groups?${params.toString()}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Fetch subpackages for a given groupId
export const listByGroup = async (groupId) => {
  const response = await apiMiddleware.get(`/package-groups/${groupId}`);
  return response.data;
};

// copy package
export const copyPackage = async (packageId) => {
  const response = await apiMiddleware.get(`/package-clone/${packageId}`);
  return response.data;
};

// delete package
export const deletePackage = async (packageGroupId, packageId) => {
  const response = await apiMiddleware.delete(`/package-group/${packageGroupId}/package/${packageId}`);
  return response.data;
};

// change group name
export const changeGroupName = async (groupId, name) => {
  const response = await apiMiddleware.post(`/package-group/${groupId}?_method=PUT`, { name });
  return response.data;
};

// GENERAL INFO  ==========
// Fetch suitable for options
export const fetchSuitableFor = async () => {
  const response = await apiMiddleware.get("/list-suitable-masters");
  return response.data;
};

// Fetch activities
export const fetchActivities = async () => {
  const response = await apiMiddleware.get("/list-activity-masters");
  return response.data;
};

export const createActivityMaster = async ({ name }) => {
  const response = await apiMiddleware.post("/create-activity-master", {
    name,
  });
  return response.data;
};

// Fetch package details
export const fetchPackageDetails = async (packageId) => {
  const response = await apiMiddleware.get(`/packages/${packageId}`);
  return response.data;
};

// Create new package
export const createGeneralInfo = async (packageData) => {
  const response = await apiMiddleware.post(
    "/package-general-info",
    packageData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// Get general info
export const getGeneralInfo = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-general-info/${packageId}`
  );
  return response.data;
};

// Update package
export const updateGeneralInfo = async (packageId, packageData) => {
  const response = await apiMiddleware.post(
    `/package-general-info/${packageId}?_method=PUT`,
    packageData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// Save package as draft
export const saveGeneralInfoAsDraft = async (packageData) => {
  const response = await apiMiddleware.post(
    "/package-general-info/draft",
    packageData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// Delete general info images
export const deleteGeneralInfoImages = async (imageId) => {
  const response = await apiMiddleware.delete(`/package-image/${imageId}`);
  return response.data;
};

// delete days in each destination
export const deleteDaysInEachDestination = async (itemId) => {
  const response = await apiMiddleware.delete(`/package-days-each-destination/${itemId}`);
  return response.data;
};



// ITINEAR SERVICES ==========
// basic itinerary
export const fetchBasicItinerary = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-itinerary?package_id=${packageId}`
  );
  return response.data;
};

// Itineary Food Master
export const fetchItineraryFoodMaster = async () => {
  const response = await apiMiddleware.get("/get-food-masters");
  return response.data;
};

// Itineary Attraction Master
export const fetchItineraryAttractionMaster = async () => {
  const response = await apiMiddleware.get("/get-attraction-masters");
  return response.data;
};

export const deleteItineraryAttractionMaster = async (id) => {
  const response = await apiMiddleware.delete(`/itinerary-attraction-master/${id}`);
  return response.data;
};

// update itinerary
export const buildItineraryUpdateFormData = (data) => {
  const formData = new FormData();
  Object.entries(data || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value);
    } else {
      formData.append(key, value);
    }
  });
  return formData;
};

export const updateItinerary = async (packageId, itineraryData) => {
  const formData = buildItineraryUpdateFormData(itineraryData);
  const response = await apiMiddleware.post(
    `/package-itinerary/${packageId}?_method=PUT`,
    formData
  );
  return response.data;
};

export const reorderItinerary = async ({ package_id, order }) => {
  const response = await apiMiddleware.post(`/package-itinerary-reorder`, {
    package_id,
    order,
  });
  return response.data;
};

export const deleteItineraryDay = async (itineraryDayId) => {
  const response = await apiMiddleware.delete(`/package-itinerary/${itineraryDayId}`);
  return response.data;
};

//  get itinearay by id
export const getItinerary = async (packageId) => {
  const response = await apiMiddleware.get(`/package-itinerary/${packageId}`);
  return response.data;
};

// update stage status for itinerary
export const updateItineraryStageStatus = async ({
  package_id,
  current_stage,
  is_draft,
}) => {
  const response = await apiMiddleware.post(`/package-itinerary-continue`, {
    package_id,
    current_stage,
    is_draft,
  });
  return response.data;
};

// STAY SERVICES ==========

// get stay by id
export const stayMaster = async () => {
  const response = await apiMiddleware.get("/list-stay-masters");
  return response.data;
};

// hotel masters
export const hotelMaster = async (destination, packageId) => {
  const response = await apiMiddleware.get(
    `/list-supplier-hotel-masters/${destination}`,
    {
      params: {
        package_id: packageId,
      },
    }
  );
  return response.data;
};

// existing hotel masters
export const hotelDestinationMaster = async (packageId) => {
  const response = await apiMiddleware.get(`/old-hotel-destinations`, {
    params: {
      package_id: packageId,
    },
  });
  return response.data;
};

// get stay data
export const stayData = async (packageId) => {
  const response = await apiMiddleware.get(`/package-stay/${packageId}`);
  return response.data;
};

// add stay data
export const addPackageStay = async (data) => {
  const response = await apiMiddleware.post("/package-stay", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// add stay data
export const packageStaySaveContinue = async (data) => {
  const response = await apiMiddleware.post("/package-stay-continue", data);
  return response.data;
};

// update stay data
export const updatePackageStay = async (data, stayId) => {
  const response = await apiMiddleware.post(
    `/package-stay/${stayId}?_method=PUT`,
    data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// delete stay data
export const deletePackageStay = async (stayId) => {
  const response = await apiMiddleware.delete(`/package-stay/${stayId}`);
  return response.data;
};

// delete hotel from stay
export const deleteHotelFromStay = async (hotelId) => {
  const response = await apiMiddleware.delete(`/package-stay-hotel/${hotelId}`);
  return response.data;
};

// INCLUSION SERVICES ==========

// get inclusion master
export const inclusionMaster = async () => {
  const response = await apiMiddleware.get(`/inclusion-master-list`);
  return response.data;
};

// inclusion data
export const inclusionData = async (packageId) => {
  const response = await apiMiddleware.get(`/package-inclusion/${packageId}`);
  return response.data;
};

// save inclusion data
export const saveInclusionData = async (data) => {
  const response = await apiMiddleware.post(`/package-inclusion`, data);
  return response.data;
};


// update inclusion data
export const updateInclusionData = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-inclusion/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// PRICING SERVICES ==========


// package price stop sales
export const addPackagePriceStopSales = async (data) => {
  console.log("data", data);
  const response = await apiMiddleware.post(`/package-price-stop-sale`, data);
  return response.data;
};


export const listPackagePriceStopSales = async (
  packageId,
  packageStayCategoryId
) => {
  const response = await apiMiddleware.get(
    `/package-price-stop-sale?package_id=${packageId}&package_stay_category_id=${packageStayCategoryId}`
  );
  return response.data;
};

// get pricing data
export const pricingMaster = async (packageId) => {
  const response = await apiMiddleware.get(`/package-stay-category-masters`, {
    params: {
      package_id: packageId,
    },
  });
  return response.data;
};

// add rates
export const addRates = async (data) => {
  const response = await apiMiddleware.post("/package-price-rates", data);
  return response.data;
};

// get recently added rates based on package id and stay category id and package stay category id
export const getRecentlyAddedRates = async (
  type,
  packageId,
  stayCategoryId,
  packageStayCategoryId
) => {
  // Validate rate type
  const validTypes = ["normal", "seasonal", "stop"];
  if (!validTypes.includes(type)) {
    throw new Error(`Invalid rate type: ${type}`);
  }

  const response = await apiMiddleware.get(`/package-price-${type}`, {
    params: {
      package_id: packageId,
      stay_category_id: stayCategoryId,
      package_stay_category_id: packageStayCategoryId,
    },
  });
  return response.data;
};

// get Pricing data
export const getExistingPricingData = async (
  packageId,
  packageStayCategoryId
) => {
  const response = await apiMiddleware.get(
    `/package-price-rates?package_id=${packageId}&package_stay_category_id=${packageStayCategoryId}`
  );
  return response.data;
};

// get base price
export const getBasePrice = async (data) => {
  const response = await apiMiddleware.get(`/package-price-base-rates`, {
    params: data,
  });
  return response.data;
};
// insert base price
export const insertBasePrice = async (data) => {
  const response = await apiMiddleware.post(`/package-price-base-rates`, data);
  return response.data;
};
// update base price
export const updateBasePrice = async (data, id) => {
  const response = await apiMiddleware.post(
    `/package-price-base-rates/${id}?_method=PUT`,
    data
  );
  return response.data;
};

// save and continue pricing
export const saveAndContinuePricing = async (data) => {
  const response = await apiMiddleware.post(`/package-price-save-and-continue`, data);
  return response.data;
};

// save and continue pricing
export const getDiscountAndPaymentData = async (packageId) => {
  const response = await apiMiddleware.get(`/package-price-discount-and-payment-type?package_id=${packageId}`);
  return response.data;
};

// delete rate
export const deleteRate = async (rateId) => {
  const response = await apiMiddleware.delete(`/package-price-rates/${rateId}`);
  return response.data;
};

// update rate
export const updateRate = async (rateId, data) => {
  const response = await apiMiddleware.post(
    `/package-price-rates/${rateId}?_method=PUT`,
    data
  );
  return response.data;
};

// delete stop sale
export const deleteStopSale = async (stopSaleId) => {
  const response = await apiMiddleware.delete(`/package-stop-sale/${stopSaleId}`);
  return response.data;
};

// get all stop sales for supplier
export const getAllStopSales = async () => {
  const response = await apiMiddleware.get('/package-stop-sales-all');
  return response.data;
};

// update stop sale
export const updateStopSale = async (stopSaleId, data) => {
  const response = await apiMiddleware.put(`/package-stop-sale/${stopSaleId}`, data);
  return response.data;
};


// ADDITIONAL INFO SERVICES ==========

// add additional info
export const additionalInfoData = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-additional-info/${packageId}`
  );
  return response.data;
};

// update additional info
export const updateAdditionalInfo = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-additional-info/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// TERMS AND CONDITIONS SERVICES ==========

// get terms and conditions
export const getTermsAndConditions = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-terms-and-conditions/${packageId}`
  );
  return response.data;
};

// update terms and conditions
export const updateTermsAndConditions = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-terms-and-conditions/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// FAQ SERVICES ==========

// get faq
export const getFaq = async (packageId) => {
  const response = await apiMiddleware.get(`/package-faq/${packageId}`);
  return response.data;
};

// update faq
export const updateFaq = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-faq/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// add faq
export const addFaq = async (packageId, data) => {
  console.log("data", data);
  const response = await apiMiddleware.post(`/package-faq`, data);
  return response.data;
};

// delete faq
export const deleteFaq = async (packageId) => {
  const response = await apiMiddleware.delete(`/package-faq/${packageId}`);
  return response.data;
};

// cancellation services ==========

// store cancellation policy
export const createCancellationPolicy = async (data) => {
  const response = await apiMiddleware.post(
    `/package-cancellation-policy`,
    data
  );
  return response.data;
};

// get cancellation policy
export const getCancellationPolicy = async (packageId) => {
  const response = await apiMiddleware.get(
    `/package-cancellation-policy/${packageId}`
  );
  return response.data;
};

// update cancellation policy
export const updateCancellationPolicy = async (packageId, data) => {
  const response = await apiMiddleware.post(
    `/package-cancellation-policy/${packageId}?_method=PUT`,
    data
  );
  return response.data;
};

// delete cancellation policy
export const deleteCancellationPolicy = async (packageId) => {
  const response = await apiMiddleware.post(
    `/package-cancellation-policy/${packageId}?_method=DELETE`
  );
  return response.data;
};

// SLOT SERVICES ==========
// Get all packages with slots
export const getAllPackagesWithSlots = async (date) => {
  const response = await apiMiddleware.get('/package-slots-all', {
    params: { date },
  });
  return response.data;
};

// Update slot for a specific package and date
export const updatePackageSlot = async (packageId, date, slot) => {
  const response = await apiMiddleware.put('/package-slots-update', {
    package_id: packageId,
    date: date,
    slot: slot,
  });
  return response.data;
};
